import React from 'react';
import { ArrowDownIcon, CheckIcon, GlobeIcon } from 'lucide-react';
import { H2, Section } from '../ui/Section';
import { CtaButton } from '../ui/CtaButton';
import { Countdown } from '../ui/Countdown';
import { finalFlow, finalIncludes } from '../../data/content';
export function FinalCtaSection() {
  return <Section tone="dark" narrow data-id="element-99" data-mp="2dibnorwd873d">
      <div className="text-center" data-id="element-100" data-mp="2dlg0uert6d66">
        <H2 data-id="element-101" data-mp="2riurfmtssqzq">Your Next Implant Case Deserves a Clearer Planning Framework.</H2>
        <p className="mt-5 font-display text-lg font-bold uppercase text-gold" data-id="element-102" data-mp="2rgrvkm5ys3n3">
          Stop studying implant treatment as a collection of disconnected topics.
        </p>
        <p className="mt-4 text-lg text-white/80" data-id="element-103" data-mp="3185zr78v1rmk">Imagine having a structured educational reference that helps you connect:</p>
      </div>

      <ol className="mx-auto mt-8 flex max-w-md flex-col items-center" data-id="element-104" data-mp="3a9cjrqapxkkk">
        {finalFlow.map((step, i) => <li key={step} className="flex w-full flex-col items-center" data-id="element-105" data-mp="368k86qedj3l4" data-mpi={i}>
            <span className="w-full rounded-xl bg-panel px-4 py-3 text-center font-display text-base font-extrabold uppercase ring-1 ring-line" data-id="element-106" data-mp="220kpqvvyzq74">
              {step}
            </span>
            {i < finalFlow.length - 1 && <ArrowDownIcon className="my-1.5 h-5 w-5 text-accent" aria-hidden="true" data-id="element-107" data-mp="2b1iu5fablzq8" />}
          </li>)}
      </ol>

      <div className="mt-10 text-center" data-id="element-108" data-mp="2g0lzz1y4k9z9">
        <p className="text-lg text-white/85" data-id="element-109" data-mp="2fy99u1i7qtb4">That’s what Dental Implant Clinical Roadmap™ is designed to provide.</p>
        <p className="mt-2 text-lg text-white/85" data-id="element-110" data-mp="2p10pkdi4gb8k">A more organized way to study the decisions and considerations involved in implant treatment planning.</p>
        <p className="mt-8 font-display text-lg font-bold uppercase text-accent" data-id="element-111" data-mp="2tt211x7gtxxj">Get the complete collection today</p>
        <p className="font-display text-7xl font-black text-gold sm:text-8xl" data-id="element-112" data-mp="2yq22futdecib">$27</p>
        <p className="font-display text-base font-extrabold uppercase" data-id="element-113" data-mp="33rhpttj0sv3v">USD only</p>
      </div>

      <div className="mt-8 rounded-2xl bg-panel p-6 ring-1 ring-line" data-id="element-114" data-mp="38psxbxluetix">
        <p className="text-sm font-bold uppercase tracking-wide" data-id="element-115" data-mp="2j02qdjcosabi">Your purchase includes:</p>
        <ul className="mt-4 grid gap-2.5 sm:grid-cols-2" data-id="element-116" data-mp="2e2axon47wk69">
          {finalIncludes.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug" data-id="element-117" data-mp="2sr7126vbx90j">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-118" data-mp="2nzyr99q37lmu" />
              {item}
            </li>)}
        </ul>
      </div>

      <div className="mt-10 flex flex-col items-center gap-6" data-id="element-119" data-mp="31tgaetev2wcc">
        <CtaButton tone="dark" label="Yes! I want the Dental Implant Clinical Roadmap™" note="Get Instant Access · One-Time Payment of $27 USD · No Monthly Fees" data-id="element-120" data-mp="2wrhajtibyhk5" />
        <Countdown label="Special launch offer ends in:" data-id="element-121" data-mp="36rrmlasmpixq" />
        <p className="flex items-center gap-1.5 text-sm text-white/75" data-id="element-122" data-mp="1hb8nbpp7hysz">
          <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-123" data-mp="1hdd3p74akqa5" />
          Currency conversion is automatic at checkout.
        </p>
      </div>

      <div className="mt-14 text-center" data-id="element-124" data-mp="3nzirp6uk4yjk">
        <p className="font-display text-xl font-extrabold uppercase leading-snug sm:text-2xl" data-id="element-125" data-mp="3o0keg8kxr9h4">
          Don’t keep your implant planning knowledge scattered across dozens of different resources.
        </p>
        <p className="mt-3 text-lg text-white/80" data-id="element-126" data-mp="3e7v6vosiafr2">Bring the essential stages together with Dental Implant Clinical Roadmap™.</p>
      </div>

      <div className="mt-8" data-id="element-127" data-mp="358rnejpffyc1">
        <CtaButton tone="dark" label="Get my complete implant clinical roadmap™" note="$27 USD · Immediate Digital Access · Lifetime Access · 7-Day Guarantee" data-id="element-128" data-mp="358ht4jxcn50j" />
      </div>
    </Section>;
}